import { isIOSPlatform } from "../utils/platformFeatures";

// Apple Health verileri yalnızca iOS WebView ile native HealthKit arasında
// taşınır. Bu modül hiçbir veriyi localStorage'a veya backend'e yazmaz.
const RESULT_EVENT = "aileHealthKitResult";
const REFRESH_EVENT = "aileHealthKitRefresh";
const pending = new Map();
let listenerAttached = false;

const callbackId = () =>
  `health-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;

const attachResultListener = () => {
  if (listenerAttached || typeof window === "undefined") return;
  listenerAttached = true;

  window.addEventListener(RESULT_EVENT, (event) => {
    const detail = event?.detail || {};
    const request = pending.get(detail.callbackId);
    if (!request) return;

    pending.delete(detail.callbackId);
    clearTimeout(request.timer);

    if (detail.ok === false) {
      const error = new Error(detail.message || "HEALTHKIT_REQUEST_FAILED");
      error.code = detail.code || "HEALTHKIT_REQUEST_FAILED";
      request.reject(error);
      return;
    }

    request.resolve(detail.data || {});
  });
};

const sendNativeRequest = (action, payload = {}, timeoutMs = 20000) => {
  if (!isIOSPlatform()) {
    return Promise.reject(Object.assign(new Error("HEALTHKIT_IOS_ONLY"), { code: "HEALTHKIT_IOS_ONLY" }));
  }

  const bridge = window?.webkit?.messageHandlers?.aileNativeBridge;
  if (!bridge?.postMessage) {
    return Promise.reject(Object.assign(new Error("HEALTHKIT_BRIDGE_NOT_READY"), { code: "HEALTHKIT_BRIDGE_NOT_READY" }));
  }

  attachResultListener();
  const id = callbackId();

  return new Promise((resolve, reject) => {
    const timer = setTimeout(() => {
      pending.delete(id);
      reject(Object.assign(new Error("HEALTHKIT_TIMEOUT"), { code: "HEALTHKIT_TIMEOUT" }));
    }, timeoutMs);

    pending.set(id, { resolve, reject, timer });
    bridge.postMessage({ action, callbackId: id, ...payload });
  });
};

export const isAppleHealthIOS = () => isIOSPlatform();

export const getHealthKitStatus = () =>
  sendNativeRequest("healthKitStatus");

export const requestHealthKitAuthorization = () =>
  sendNativeRequest("healthKitRequestAuthorization", {}, 60000);

export const readHealthKitSummary = () =>
  sendNativeRequest("healthKitReadSummary", {}, 30000);

export const openHealthKitSettings = () =>
  sendNativeRequest("healthKitOpenSettings");

export const subscribeHealthKitRefresh = (listener) => {
  if (typeof window === "undefined" || typeof listener !== "function") return () => {};
  const handler = () => listener();
  window.addEventListener(REFRESH_EVENT, handler);
  return () => window.removeEventListener(REFRESH_EVENT, handler);
};

